import {customAxios, IDUSUARIO, FDV_URL} from '../constants';

export function anularExp(codigo) {
    const config = {
        headers: {
            idUsuario: IDUSUARIO,
        },
    };

    return customAxios.delete(`${FDV_URL}/autorizacion-excepcional/solicitudes/anular/${codigo}`, config);
}

export function changeState(codigo, estado) {
    const config = {
        headers: {
            idUsuario: IDUSUARIO,
        },
    };

    const data = {
        codEstadoAut: estado,
        codSolicitud: codigo,
    };

    return customAxios.put(`${FDV_URL}/autorizacion-excepcional/solicitudes/autorizar/${codigo}`, data, config);
}






// WEBPACK FOOTER //
// ./src/utils/Excepciones.js